// Auto-generated by the generator
// Don't manually edit this file

// @flow

import {register} from './register'
import {setLoading} from './setLoading'
import {setError} from './setError'

export const gbiProjectActions = {
  register,
  setLoading,
  setError,
}
